import { modifier } from 'ember-modifier';
import { testAwareTimeout } from 'ember-simplepractice/utils/waiters';

export default modifier(async function focusAfterTransition(element) {
  await testAwareTimeout(0);
  element.focus();
});
